import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-filter-activities',
  imports: [FormsModule],
  templateUrl: './mdl-filter-activities.html',
  styleUrl: './mdl-filter-activities.css'
})
export class Mdlfilterectivities {
  constructor(
    public mdl: MatDialogRef<Mdlfilterectivities>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.filters = { ...this.filters, ...data };
    }
  }

  filters = {
    dateRange: '2m',
    activityView: 'all',
    allTypes: true,
    allStatuses: true,
    types: {
      email: false,
      listEmail: false,
      calls: false,
      tasks: false,
      events: false
    },
    statuses: {
      pendiente: false,
      enProgreso: false,
      completada: false,
      vencida: false,
      programada: false,
      cancelada: false
    }
  };

  activityTypes: Array<keyof typeof this.filters.types> = [
    'email',
    'listEmail',
    'calls',
    'tasks',
    'events'
  ];

  statusTypes: Array<keyof typeof this.filters.statuses> = [
    'pendiente',
    'enProgreso',
    'completada',
    'vencida',
    'programada',
    'cancelada'
  ];

  toggleAllTypes() {
    if (this.filters.allTypes) {
      for (const key of this.activityTypes) {
        this.filters.types[key] = true;
      }
    } else {
      for (const key of this.activityTypes) {
        this.filters.types[key] = false;
      }
    }
  }

  onTypeChange() {
    const allTypesSelected = this.activityTypes.every(key => this.filters.types[key]);
    const anyTypeSelected = this.activityTypes.some(key => this.filters.types[key]);
    
    this.filters.allTypes = allTypesSelected;
    
    if (!anyTypeSelected) {
      this.filters.allTypes = true;
      this.toggleAllTypes();
    }
  }

  toggleAllStatuses() {
    if (this.filters.allStatuses) {
      for (const key of this.statusTypes) {
        this.filters.statuses[key] = true;
      }
    } else {
      for (const key of this.statusTypes) {
        this.filters.statuses[key] = false;
      }
    }
  }

  onStatusChange() {
    const allStatusesSelected = this.statusTypes.every(key => this.filters.statuses[key]);
    const anyStatusSelected = this.statusTypes.some(key => this.filters.statuses[key]);
    
    this.filters.allStatuses = allStatusesSelected;
    
    if (!anyStatusSelected) {
      this.filters.allStatuses = true;
      this.toggleAllStatuses();
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  applyFilters() {
    this.mdl.close(this.filters);
  }
}